// components/Loader.js
import { ClipLoader } from "react-spinners";
import "./Loader.css";
const Loader = () => {
  return (
    <div className="overlay">
      <div className="flex justify-center items-center h-screen">
        <ClipLoader color="#3498db" loading={true} size={50} />
      </div>
    </div>
  );
};

export default Loader;
